import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesConstants } from 'src/app/constants/RoutesConstants';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-no-permissions',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.scss']
})
export class NoPermissionsComponent implements OnInit {
  setAdmin: boolean;
  status = true;
  closeResult: string;
  constructor(
    public themeService: ThemeService,
    public authService: AuthServiceService,
    public router: Router
  ) { }

  ngOnInit(): void {
  }

  menuToggle() {
    this.themeService.menuToggle();
  }

  ngAfterContentInit() {
    this.themeService.getColorCookie();
  }

  ngAfterViewInit() {
    if (this.themeService.getThemeCookie()) {
      this.themeService.toggleField()
    }
  }
  closeAlert(){
    this.router.navigate([RoutesConstants.VENTURELAYOUT, RoutesConstants.VENTUREDASHBOARD]);
  }
}
